import { Fragment } from "react";

import { EmojiRenderer } from "@/react/components/shared/EmojiRenderer";
import { customEmojiIconUrl } from "@/react/components/shared/uikit/EmojiPickerV3/data/icons";
import { customEmojiShapeUrl } from "@/react/components/shared/uikit/EmojiPickerV3/data/shapes";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { activeStorageBlobUrl } from "@/react/helpers/urlHelpers";
import { APPEARANCE } from "@/react/providers/Theme";
import {
  type BenefitPropertyIcon,
  type CustomIcon,
  EMOJI_TYPE,
  type EmojiIcon,
  type ShapeIcon,
} from "@/react/types/PaywallCustomization";

const defaultClassName = "!max-w-6 !p-0 !max-h-6";

interface IconProps {
  hide?: boolean;
  icon: BenefitPropertyIcon;
}

export const Icon = ({ icon, hide }: IconProps) => {
  const { emoji_type } = icon;
  let emojiRendererProps = {};
  const appearance = APPEARANCE.LIGHT;

  if (emoji_type === EMOJI_TYPE.ICONS) {
    const { identifier } = icon as ShapeIcon;

    emojiRendererProps = {
      className: classNames(defaultClassName),
      emptyIcon: Fragment,
      customEmojiUrl: customEmojiIconUrl(identifier, APPEARANCE.LIGHT) || null,
      customEmojiDarkUrl:
        customEmojiIconUrl(identifier, APPEARANCE.LIGHT) || null,
    };
  }

  if (emoji_type === EMOJI_TYPE.EMOJI) {
    const { emoji } = icon as EmojiIcon;

    emojiRendererProps = {
      className: classNames("!p-0 text-[1.5rem] leading-8"),
      emptyIcon: Fragment,
      emoji: emoji,
    };
  }

  if (emoji_type === EMOJI_TYPE.CUSTOM) {
    emojiRendererProps = {
      className: classNames(defaultClassName),
      emptyIcon: Fragment,
      customEmojiUrl: activeStorageBlobUrl(icon as CustomIcon),
      customEmojiDarkUrl: activeStorageBlobUrl(icon as CustomIcon),
    };
  }

  if (emoji_type === EMOJI_TYPE.SHAPES) {
    const { identifier } = icon as ShapeIcon;

    emojiRendererProps = {
      className: classNames("!p-0 !w-5 !h-5"),
      emptyIcon: Fragment,
      customEmojiUrl: customEmojiShapeUrl(identifier) || null,
      customEmojiDarkUrl: customEmojiShapeUrl(identifier) || null,
    };
  }

  return (
    <div
      className={classNames("flex size-8 items-center justify-center", {
        invisible: hide,
      })}
      data-testid="benefit-icon"
    >
      <EmojiRenderer {...emojiRendererProps} appearance={appearance} />
    </div>
  );
};
